import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Layout({ children }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [maqExpanded, setMaqExpanded] = useState(
    location.pathname.startsWith('/staff/maquinistas') ||
    location.pathname.startsWith('/staff/calendario') ||
    location.pathname.startsWith('/staff/informes-maq')
  );
  const [locoExpanded, setLocoExpanded] = useState(
    location.pathname.startsWith('/staff/locomotoras') || 
    location.pathname.startsWith('/staff/flota') ||
    location.pathname.startsWith('/staff/historial-flota') ||
    location.pathname.startsWith('/staff/gestion-flota')
  );

  // Estado de la barra lateral
  const [collapsed, setCollapsed] = useState(false); // escritorio: colapsado
  const [mobileOpen, setMobileOpen] = useState(false); // móvil: abierto

  // Detectar si es móvil
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // Cerrar sidebar móvil al navegar
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const sidebarWidth = isMobile ? 220 : (collapsed ? 60 : 220);
  const isActive = (path) => location.pathname === path;
  const isActiveGroup = (prefix) => location.pathname.startsWith(prefix);

  const navItem = (to, icon, label, exact = true) => (
    <Link to={to} style={{
      display: 'flex', alignItems: 'center', gap: collapsed && !isMobile ? 0 : 10,
      padding: '9px 12px', borderRadius: 8, marginBottom: 2, textDecoration: 'none',
      justifyContent: collapsed && !isMobile ? 'center' : 'flex-start',
      background: (exact ? isActive(to) : isActiveGroup(to)) ? '#f0f0f0' : 'transparent',
      color: (exact ? isActive(to) : isActiveGroup(to)) ? '#1a1a1a' : '#555',
      fontWeight: (exact ? isActive(to) : isActiveGroup(to)) ? 500 : 400, fontSize: 14,
      title: collapsed && !isMobile ? label : undefined
    }}>
      <span style={{ fontSize: 16, flexShrink: 0 }}>{icon}</span>
      {(!collapsed || isMobile) && <span>{label}</span>}
    </Link>
  );

  const subNavItem = (to, label) => {
    if (collapsed && !isMobile) return null;
    return (
      <Link to={to} style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px 7px 32px',
        borderRadius: 8, marginBottom: 2, textDecoration: 'none',
        background: isActive(to) ? '#f0f0f0' : 'transparent',
        color: isActive(to) ? '#1a1a1a' : '#777',
        fontWeight: isActive(to) ? 500 : 400, fontSize: 13
      }}>
        <span style={{ width: 4, height: 4, borderRadius: '50%', background: isActive(to) ? '#1a1a1a' : '#ccc', flexShrink: 0 }} />
        {label}
      </Link>
    );
  };

  const sidebarVisible = isMobile ? mobileOpen : true;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f4f0' }}>

      {/* Overlay móvil */}
      {isMobile && mobileOpen && (
        <div onClick={() => setMobileOpen(false)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 99
        }} />
      )}

      {/* Barra lateral */}
      {sidebarVisible && (
        <aside style={{
          width: sidebarWidth, background: '#fff', borderRight: '1px solid #e5e5e5',
          display: 'flex', flexDirection: 'column', position: 'fixed', height: '100vh', zIndex: 100,
          transition: 'width 0.2s ease',
          left: isMobile ? 0 : 0
        }}>
          {/* Cabecera */}
          <div style={{ padding: '16px 12px', borderBottom: '1px solid #e5e5e5', display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight: 64 }}>
            {(!collapsed || isMobile) && (
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <img src='/loconode-small.png' alt='Loconode' style={{ height: 28, width: 'auto' }} />
                  {(!collapsed || isMobile) && <span style={{ fontWeight: 600, fontSize: 14, color: '#1a1a1a' }}>Loconode</span>}
                </div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{usuario?.nombre} {usuario?.apellidos}</div>
                <div style={{ fontSize: 10, color: '#aaa' }}>{usuario?.rol}</div>
              </div>
            )}
            {/* Botón colapsar escritorio */}
            {!isMobile && (
              <button onClick={() => setCollapsed(!collapsed)} style={{
                border: 'none', background: 'none', cursor: 'pointer', fontSize: 16,
                color: '#888', padding: 4, borderRadius: 6, flexShrink: 0
              }}>
                {collapsed ? '→' : '←'}
              </button>
            )}
          </div>

          {/* Navegación */}
          <nav style={{ flex: 1, padding: '12px 8px', overflowY: 'auto' }}>
            {navItem('/staff/dashboard', '▦', 'Dashboard')}

            <div>
              <button onClick={() => !collapsed || isMobile ? setLocoExpanded(!locoExpanded) : null} style={{
                display: 'flex', alignItems: 'center', gap: collapsed && !isMobile ? 0 : 10,
                padding: '9px 12px', borderRadius: 8, marginBottom: 2, width: '100%',
                border: 'none', cursor: 'pointer', textAlign: 'left', justifyContent: collapsed && !isMobile ? 'center' : 'flex-start',
                background: isActiveGroup('/staff/flota') || isActiveGroup('/staff/historial-flota') || isActiveGroup('/staff/gestion-flota') ? '#f0f0f0' : 'transparent',
                color: isActiveGroup('/staff/flota') || isActiveGroup('/staff/historial-flota') || isActiveGroup('/staff/gestion-flota') ? '#1a1a1a' : '#555',
                fontWeight: 400, fontSize: 14
              }}>
                <span style={{ fontSize: 16, flexShrink: 0 }}>🚂</span>
                {(!collapsed || isMobile) && <><span style={{ flex: 1 }}>Locomotoras</span><span style={{ fontSize: 10, color: '#aaa' }}>{locoExpanded ? '▲' : '▼'}</span></>}
              </button>
              {locoExpanded && (!collapsed || isMobile) && (
                <div style={{ marginBottom: 4 }}>
                  {subNavItem('/staff/flota', 'Flota')}
                  {subNavItem('/staff/historial-flota', 'Historial')}
                  {subNavItem('/staff/gestion-flota', 'Gestion')}
                  {subNavItem('/staff/mapa-flota', 'Mapa flota')}
                {subNavItem('/staff/combustible-adblue', 'Combustible')}
                </div>
              )}
            </div>

            {navItem('/staff/servicios-predefinidos', '🚆', 'Serv. predefinidos')}
            {navItem('/staff/partes', '📋', 'Partes recibidos')}
            {navItem('/staff/consulta-tren', '🔍', 'Consulta de tren')}

            <div>
              <button onClick={() => !collapsed || isMobile ? setMaqExpanded(!maqExpanded) : null} style={{
                display: 'flex', alignItems: 'center', gap: collapsed && !isMobile ? 0 : 10,
                padding: '9px 12px', borderRadius: 8, marginBottom: 2, width: '100%',
                border: 'none', cursor: 'pointer', textAlign: 'left', justifyContent: collapsed && !isMobile ? 'center' : 'flex-start',
                background: isActiveGroup('/staff/maquinistas') || isActiveGroup('/staff/calendario') || isActiveGroup('/staff/informes-maq') ? '#f0f0f0' : 'transparent',
                color: isActiveGroup('/staff/maquinistas') || isActiveGroup('/staff/calendario') || isActiveGroup('/staff/informes-maq') ? '#1a1a1a' : '#555',
                fontWeight: 400, fontSize: 14
              }}>
                <span style={{ fontSize: 16, flexShrink: 0 }}>👤</span>
                {(!collapsed || isMobile) && <><span style={{ flex: 1 }}>Maquinistas</span><span style={{ fontSize: 10, color: '#aaa' }}>{maqExpanded ? '▲' : '▼'}</span></>}
              </button>
              {maqExpanded && (!collapsed || isMobile) && (
                <div style={{ marginBottom: 4 }}>
                  {subNavItem('/staff/maquinistas', 'Plantilla')}
                  {subNavItem('/staff/calendario', 'Calendario')}
                  {subNavItem('/staff/informes-maq', 'Informes')}
                </div>
              )}
            </div>

            {navItem('/staff/documentacion', '📄', 'Documentación')}
            {navItem('/staff/admin-usuarios', '⚙️', 'Admin usuarios')}
          </nav>

          {/* Cerrar sesión */}
          <div style={{ padding: '12px', borderTop: '1px solid #e5e5e5' }}>
            <button onClick={() => { logout(); navigate('/login'); }} style={{
              width: '100%', padding: '8px', borderRadius: 8, border: '1px solid #e5e5e5',
              background: 'transparent', cursor: 'pointer', fontSize: collapsed && !isMobile ? 16 : 13, color: '#555'
            }}>
              {collapsed && !isMobile ? '↩' : 'Cerrar sesion'}
            </button>
          </div>
        </aside>
      )}

      {/* Botón hamburguesa móvil */}
      {isMobile && !mobileOpen && (
        <button onClick={() => setMobileOpen(true)} style={{
          position: 'fixed', top: 12, left: 12, zIndex: 101,
          background: '#fff', border: '1px solid #e5e5e5', borderRadius: 8,
          padding: '8px 10px', cursor: 'pointer', fontSize: 18, boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          ☰
        </button>
      )}

      {/* Contenido principal */}
      <main style={{
        marginLeft: isMobile ? 0 : sidebarWidth,
        flex: 1, padding: isMobile ? '56px 16px 24px' : 24,
        minHeight: '100vh', transition: 'margin-left 0.2s ease'
      }}>
        {children}
      </main>
    </div>
  );
}
